import React from "react";
import { message } from "antd";
import styled from "styled-components";
import { DeleteOutlined } from "@ant-design/icons";

// import colors from "constants/palette";
import Button from "components/buttons/Button";
import Input from "components/inputs/Input";
import Upload from "components/buttons/Upload";

export default function HeroBanners({ oldData, onSubmit }) {
  const [inputValue, setInputValue] = React.useState(null);
  const [list, setList] = React.useState(oldData ?? []);
  const [images, setImages] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const handleInput = ({ target }) => {
    setInputValue(target.value);
  };
  const handleAdd = () => {
    if (!inputValue) {
      message.error("لطفا متن ویژگی را تایپ کنید.");
      return false;
    }
    setList((e) => [...e, inputValue]);
    setInputValue(null);
    return false;
  };
  const handleEdit = ({ target }) => {
    let index = Number(target.dataset.index);
    if (!target.innerText) {
      target.innerText = list[index];
      message.error("لطفا متن ویژگی را تایپ کنید.");
      return false;
    }
    if (target.innerText !== list[index]) {
      setList((list) => {
        let temp = [...list];
        temp[index] = target.innerText;
        return temp;
      });
      message.success("با موفقیت آپدیت شد.");
    }
    return;
  };

  const handleDelete = (key) => {
    setList((e) => {
      let newList = [...e];
      newList.splice(key, 1);
      console.log(key, newList);
      return newList;
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleAdd();
    }
  };

  return (
    <>
      <Container>
        <ol>
          {list?.length
            ? list?.map((item, key) => (
                <li key={key}>
                  <Upload
                    maxAllowed={1}
                    setImage={(x) => {}}
                    addedImages={item?.image ? [item?.image] : []}
                    key={oldData ? oldData.id + "upload" : "upload-new"}
                    index={() =>
                      setTimeout(() => {
                        return oldData ? oldData.id : 0;
                      }, 100)
                    }
                  />
                  <span
                    data-index={key}
                    contentEditable="true"
                    className="notranslate"
                    translate="no"
                    suppressContentEditableWarning={true}
                    onBlur={handleEdit}
                  >
                    {item}
                  </span>{" "}
                  <DeleteOutlined
                    className="delete"
                    onClick={() => handleDelete(key)}
                  />
                </li>
              ))
            : null}
        </ol>
        <AddContainer>
          <h3>بنر جدید</h3>
          <Input
            value={inputValue}
            onChange={handleInput}
            onKeyDown={handleKeyDown}
            placeholder="نام ( مشاهده فقط ادمین )"
          />
          <Button type="button" size="middle" onClick={handleAdd}>
            اضافه کردن{" "}
          </Button>
        </AddContainer>
      </Container>
    </>
  );
}

const Container = styled.div`
  margin-top: 3rem;
  text-align: start;

  & ol {
    list-style-position: inside;
    margin-top: 1rem;
  }

  & li {
    padding: 7px;
    border-radius: 4px;
    margin-bottom: 8px;
    border: 1px dashed #d5d5d5;
    overflow: auto;

    & .edit {
      margin-right: auto;
      float: left;
      font-size: 18px;
      cursor: pointer;
      padding: 2px 8px;
    }

    & .delete {
      color: red;
      margin-right: auto;
      float: left;
      font-size: 18px;
      cursor: pointer;
      padding: 2px 8px;
    }
  }
  & .ant-form-item {
    margin-bottom: 0px;
  }
`;
const AddContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  input,
  button {
    height: 38px;
    display: flex;
    align-items: center;
  }

  & button {
    flex: 1 1 100%;
    text-align: center;
    justify-content: center;
  }
  & > div {
    margin-top: 0;
    margin-left: 9px;
    width: 50%;
  }

  border: 1px dashed gray;
  padding: 1rem;
  border-radius: 7px;

  & h3 {
    flex: 1 1 100%;
  }
`;
